import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import {
  Popup,
  EditableComponent,
  Loading,
  InputField,
} from 'arteia-js/components';

import { API } from 'arteia-js/services';
import validator from 'validator';
import getUTMParams from '../getUTMParams';

class RegisterFromInvitation extends EditableComponent {
  state = {
    consumedChecked: false,
    registerErrored: false,
    registering: false,
    registerSuccessful: false,
    errorMessage: '',
    email: '',
    fullname: '',
    passwordA: '',
    passwordB: '',
  };

  staticTexts = {
    weakPassword:
      'Password should be at least 8 characters long and contain at least 1 number and 1 letter',
    differentPasswords: 'Passwords do not match',
  };

  componentDidMount() {
    this.checkConsumed();
  }

  checkConsumed = () => {
    const { history, match } = this.props;
    const { uuid } = match.params;

    API.post('/register/begin', {
      accountInvitationId: uuid,
    })
      .then(({ email }) => {
        history.push(`/sign-up?email=${encodeURIComponent(email)}`);
      })
      .catch(() => {
        history.push('/login');
      });
  };

  registerConfirm = () => {
    const { passwordA: password, fullname } = this.state;

    const { inputsFilled, strongPassword, passwordsSame, emailCorrect } =
      this.isDataCorrect();
    const allowSave =
      inputsFilled && strongPassword && passwordsSame && emailCorrect;

    if (!allowSave) {
      return this.setState({
        registerErrored: true,
      });
    }

    const { match } = this.props;

    const { uuid } = match.params;

    this.setState({
      registering: true,
    });

    return API.post('/register/confirm', {
      accountInvitationId: uuid,
      password,
      fullname,
      utmParams: getUTMParams(this.props.location),
    })
      .then((res) => {
        this.setState({
          registering: false,
          registerSuccessful: true,
        });

        setTimeout(() => {
          const query = {
            token: res.token,
            returnTo: 'accounts-client/welcome',
          };
          window.location.assign(`/redirect?${queryString.stringify(query)}`);
        }, 1500);
      })
      .catch(() => {
        this.setState({
          registering: false,
          registerErrored: true,
          errorMessage: 'Something went wrong. Try again in few minutes.',
        });
      });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.registerConfirm();
    }
  };

  isDataCorrect = () => {
    const { email, passwordA, passwordB } = this.state;

    const inputsFilled = passwordA.length !== 0 && passwordB.length !== 0;

    const strongPassword =
      passwordA.length > 7 &&
      /\d/.test(passwordA) &&
      /[a-zA-Z]/.test(passwordA);

    const passwordsSame = passwordA === passwordB;

    const emailCorrect = validator.isEmail(email);

    return {
      inputsFilled,
      strongPassword,
      passwordsSame,
      emailCorrect,
    };
  };

  render() {
    const {
      registerSuccessful,
      registerErrored,
      registering,
      consumedChecked,
      errorMessage,
      email,
      passwordA,
      passwordB,
    } = this.state;

    const { strongPassword, passwordsSame } = this.isDataCorrect();

    return (
      <Popup size='form' noTitle noCloseHandler className='form'>
        {!registerErrored && registerSuccessful ? (
          <div className='popup-content'>
            <div className='email-sent'>
              <i className='icon-icon_ok' />
              <h1>Success</h1>
              <p className='text-center'>
                Your account was successfully registered.
              </p>
              <p className='muted text-center'>Redirecting...</p>
            </div>
          </div>
        ) : (
          <Fragment>
            <div className='popup-content'>
              <h1>Register an Account</h1>

              {!consumedChecked && (
                <div className='text-center'>
                  <Loading />
                </div>
              )}

              {consumedChecked && registering && (
                <div className='text-center'>
                  <Loading />
                </div>
              )}

              {consumedChecked && !registering && (
                <Fragment>
                  <InputField readOnly label={'Email'} value={email} />

                  <InputField
                    value={passwordA}
                    onChange={this.onFieldChange('passwordA')}
                    label={'Password'}
                    type={'password'}
                    autoFocus
                    hasErrored={registerErrored && !strongPassword}
                    errorMessage={this.staticTexts.weakPassword}
                  />

                  <InputField
                    value={passwordB}
                    onChange={this.onFieldChange('passwordB')}
                    handleKeyPress={this.handleKeyPress}
                    label={'Confirm Password'}
                    type={'password'}
                    hasErrored={registerErrored && !passwordsSame}
                    errorMessage={this.staticTexts.differentPasswords}
                  />

                  <div className='form-msg'>
                    <span className='error-msg'>
                      {registerErrored && errorMessage}
                    </span>
                  </div>

                  <div className='help-msg'>
                    By registering you agree to our <br />
                    <a href='/terms.html'>Terms and Conditions</a>.
                  </div>
                </Fragment>
              )}
              <button className='art-btn' onClick={this.registerConfirm}>
                Create an Account
              </button>

              <Link className='secondary-link' to='/'>
                I already have an account
              </Link>
            </div>
          </Fragment>
        )}
      </Popup>
    );
  }
}

RegisterFromInvitation.propTypes = {};
RegisterFromInvitation.defaultProps = {};

export default RegisterFromInvitation;



// WEBPACK FOOTER //
// ./src/scenes/RegisterFromInvitation/index.js